import { fetchMonthlyData, fetchMonthlyCoinsList, fetchCompareMonthly } from "@/Groups/Scanner/private/api/monthlyData";

const state = () => ({
  monthly: [],
  compareMonthly: [],
  isReady: false,
  isLoading: false,
  isLoadingNextData: false,
  nextPage: 1,
  totalPages: 1,
  isOpened: false,
  idActiveMonthly: null,
});

const actions = {
  async updateMonthlyList({ state, commit }, { custom_tag_id, base_coin_id, tag_id, page }){
    try{
      let params = {};
      if(base_coin_id) params['base_coin_id'] = base_coin_id;
      if(custom_tag_id) params['custom_tag_id'];
      if(tag_id) params['tag_id'] = tag_id;
      if(page) params['page'] = page;
      commit('SET_LOADING_FLAG', true);
      const { results, next_page, total_pages } = await fetchMonthlyData(params);
      commit('SET_READY_FLAG', true);
      commit('SET_DATA', results);
      commit('SET_NEXT_PAGE_NUMBER', next_page);
      commit('SET_TOTAL_PAGES_NUMBER', total_pages);
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async nextMonthlyData({ state, commit, dispatch }, { base_coin_id, compare_id, tag_id, page, usd }){
    try{
      if(state.totalPages === state.nextPage) return;
      let params = {};
      if(base_coin_id) params['base_coin_id'] = base_coin_id;
      if(tag_id) params['tag_id'] = tag_id;
      if(usd) params['usd'] = true;
      if(page) params['page'] = page;
      commit('SET_LOADING_NEXT_DATA_FLAG', true);
      const { results, next_page } = await fetchMonthlyData(params);
      if(compare_id){
        await dispatch('loadCompare', { base_coin_id, page, compare_id, usd });
      }
      commit('SET_NEW_DATA', results);
      commit('SET_NEXT_PAGE_NUMBER', next_page);
    }catch(err){
      console.warn('Ошибка', err)
    }finally{
      commit('SET_LOADING_NEXT_DATA_FLAG', false);
    }
  },

  async loadCoinsList({ state, commit }, params){
    try{
      commit('SET_ACTIVE_MONTHLY_ID', params.period);
      return await fetchMonthlyCoinsList(params);
    } catch(err){
      console.warn('Ошибка', err)
    } finally{
      commit('SET_LOADING_FLAG', false);
    }
  },

  async loadCompare({ state, commit, dispatch }, params) {
    try {
      commit('SET_LOADING_FLAG', true);
      const { results } = await fetchCompareMonthly(params);
      const page = params.page || 1;
      (page === 1) ? commit('SET_COMPARE_MONTHLY', results) : commit('SET_NEW_COMPARE_MONTHLY', results);
      return results;
    } catch (err) {
    } finally {
      commit('SET_LOADING_FLAG', false);
    }
  },

  async resetCompare({ commit }) {
    commit('SET_COMPARE_MONTHLY', null);
  },

  setActiveMonthlyId({ commit }, id) {
    commit('SET_ACTIVE_MONTHLY_ID', id);
  },

  toggleOpended({ state, commit }){
    const status = (state.isOpened) ? false : true;
    commit('SET_OPENED_LIST_FLAG', status);
  },

  resetMonthly({ commit }) {
    commit('SET_DATA', []);
    commit('SET_COMPARE_MONTHLY', []);
    commit('SET_READY_FLAG', false);
    commit('SET_LOADING_FLAG', false);
    commit('SET_LOADING_NEXT_DATA_FLAG', false);
    commit('SET_NEXT_PAGE_NUMBER', 1);
    commit('SET_TOTAL_PAGES_NUMBER', 1);
    commit('SET_OPENED_LIST_FLAG', false);
    commit('SET_ACTIVE_MONTHLY_ID', null);
  },
};

const mutations = {
  SET_DATA(state, data){ state.monthly = data; },

  SET_NEW_DATA(state, data){ state.monthly = [...state.monthly, ...data]; },

  SET_COMPARE_MONTHLY(state, data) { state.compareMonthly = data; },

  SET_NEW_COMPARE_MONTHLY(state, data){ state.compareMonthly = [...state.compareMonthly, ...data]; },

  SET_READY_FLAG(state, status = true){ state.isReady = status },

  SET_LOADING_FLAG(state, status){ state.isLoading = status },
  
  SET_OPENED_LIST_FLAG(state, status){ state.isOpened = status },

  SET_LOADING_NEXT_DATA_FLAG(state, status){ state.isLoadingNextData = status },

  SET_NEXT_PAGE_NUMBER(state, number){ state.nextPage = number },

  SET_TOTAL_PAGES_NUMBER(state, number){ state.totalPages = number },

  SET_ACTIVE_MONTHLY_ID(state, id){ state.idActiveMonthly = id; }
};

const getters = {
  //Возвращает весь список периодов
  allMonthly: (state) => state.monthly,
  //Флаг, указывающий, были ли периоды успешно загружены
  isMonthlyReady: (state) => state.isReady,
  //Флаг, указывающий, выполняется ли загрузка периодов в данный момент
  isMonthlyLoading: (state) => state.isLoading,
  //Флаг, указывающий, выполняется ли подгрузка новых данных в данный момент
  isMonthlyNextLoading: (state) => state.isLoadingNextData,
  //Номер следующей страницы
  nextPageNumber: (state) => state.nextPage,
  //Возвращает период по его ID, если найден, иначе null
  getMonthlyById: (state) => (id) => state.monthly.find(p => p.id === id) || null,
  //Возвращает количество загруженных периодов
  monthlyCount: (state) => state.monthly.length,
  //Развернут ли список
  isOpenedList: (state) => state.isOpened,
  //Получить активный ID помесячного периода
  activeMonthlyId: (state) => state.idActiveMonthly,
  //Получить список compare monthly
  getCompareMonthly: (state) => state.compareMonthly,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};